import { useCommonReducer } from '@components/Shared/State/hooks';
const useOffer = (id) => useCommonReducer(`OFFER_${id}`, null);
export default useOffer;
